import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IOptionType } from '@zz2/zz2-ui';
import { IPack } from '../pack/pack';
import { IPackBillOfMaterialFormValues } from './packBillOfMaterialFormValues';
import { IPackBillOfMaterial } from './packBillOfMaterials';
import { IPackBillOfMaterialUpsert } from './packBillOfMaterialUpsert';
import { IMaterial } from '../material/material';
import { IUnitOfMeasure } from '../unitOfMeasure/unitOfMeasure';
import OptionType from '../../optionType';

export default class PackBillOfMaterialModelHelper {
    public static createFormValues = (
        billOfMaterial : IPackBillOfMaterial | null,
        packs : Array<IPack>,
        materials : Array<IMaterial>,
        unitOfMeasures : Array<IUnitOfMeasure>
    ) : IPackBillOfMaterialFormValues => {
        if (!billOfMaterial) return {
            id: 0,
            guid: uuidV4(),
            pricePerUnit: 0,
            units: 0,
            pack: null,
            material: null,
            unitOfMeasure: null,
            isActive: true,
        };

        const pack = packs.find(x => x.id === billOfMaterial.packId);
        const material = materials.find(x => x.id === billOfMaterial.materialId);
        const unitOfMeasure = unitOfMeasures.find(x => x.id === billOfMaterial.unitOfMeasureId);

        return {
            id: billOfMaterial.id,
            guid: billOfMaterial.guid,
            pricePerUnit: billOfMaterial.pricePerUnit,
            units: billOfMaterial.units,
            pack: pack ? OptionType.fromDataModel(pack) : null,
            material: material ? OptionType.fromDataModel(material) : null,
            unitOfMeasure: unitOfMeasure // TODO: OptionType.FromDataModel
                ? { label: `(${unitOfMeasure.code}) - ${unitOfMeasure.name}`, value: unitOfMeasure.id }
                : null,
            isActive: billOfMaterial.isActive,
        };
    };

    public static createUpsert = (formValues : IPackBillOfMaterialFormValues) : IPackBillOfMaterialUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            pricePerUnit: formValues.pricePerUnit,
            units: formValues.units,
            packId: Number(formValues.pack?.value ?? 0),
            materialId: Number(formValues.material?.value ?? 0),
            unitOfMeasureId: formValues.unitOfMeasure
                ? Number(formValues.unitOfMeasure.value)
                : null,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IPackBillOfMaterialFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        units: Yup.number()
            .typeError('Please enter a number.')
            .min(1, 'Must be a positive value')
            .required('Required'),
        pricePerUnit: Yup.number()
            .typeError('Please enter a number.')
            .defined(),
        pack: Yup.mixed<IOptionType>().defined().nullable(),
        material: Yup.mixed<IOptionType>().defined().nullable().required('Required'),
        unitOfMeasure: Yup.mixed<IOptionType>().defined().nullable(),
        isActive: Yup.boolean().required('Required'),
    });
}
